import React, { useCallback, useEffect } from "react";
import { useAuthContext } from "../../../context/auth";
import LandscapeProgramLayout from "../LandscapeProgramLayout";
import GredientCircularProgress from "../../GredientCircularProgress";
import BottomNav from "../BottomNav";
import { getMinute } from "../../../utils/getMinute";
import useCountListDown from "../../../hooks/useCountListDown";

function LandescapeScreen() {
  const { step, basicProgram, index, emitter } = useAuthContext();
  
  const getStepInfo = () => {
    if (!basicProgram || index === undefined) return null;
    
    switch (step) {
      case 2: // WarmUp
        const warmUpMovements = basicProgram.warmUpMovements;
        if (warmUpMovements && index < warmUpMovements.length) {
          return {
            title: "Warm Up",
            timeArray: warmUpMovements.map((_) => getMinute(_.time)),
            nowStep: step
          };
        }
        break;
      case 4: // MainExer
        const mainExers = basicProgram.mainExers;
        const timeTable = mainExers?.flatMap((_) => [
          getMinute(_.time),
          getMinute(_.restTime),
        ]) ?? [];
        if (timeTable.length > 0 && index < timeTable.length) {
          return {
            title: "Main Exer",
            timeArray: timeTable,
            nowStep: step
          };
        }
        break;
      case 5: // CoolDown
        const coolDownMovements = basicProgram.coolDownMovements;
        if (coolDownMovements && index < coolDownMovements.length) {
          return {
            title: "Cool Down",
            timeArray: coolDownMovements.map((_) => getMinute(_.time)),
            nowStep: step
          };
        }
        break;
      default:
        return null;
    }
    return null;
  };

  const stepInfo = getStepInfo();
  
  const { count, start, currentIndex, stop } = useCountListDown(
    stepInfo?.timeArray ?? [],
    useCallback(() => {}, []),
    false,
    false,
    index
  );

  useEffect(() => {
    if (stepInfo) {
      start();

      emitter.current.on("resume", () => {
        start();
      });
      emitter.current.on("pause", () => {
        stop();
      });
      return () => {
        emitter.current.off("resume");
        emitter.current.off("pause");
      };
    }
  }, [stepInfo, start, stop, emitter]);

  // 운동 중이 아니면 기본 로고 화면 표시
  if (!stepInfo) {
    return (
      <div
        className="flex justify-center items-center h-full w-full relative"
        style={{
          background:
            "var(--GMOHOB2, linear-gradient(135deg, #E3FAFF 0%, #53CAF5 100%))",
        }}
      >
        <img
          src={"/logo2.png"}
          className="w-[786px] h-[386px] absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          alt="logo"
        />
      </div>
    );
  }

  // Rest.tsx와 동일한 레이아웃
  return (
    <LandscapeProgramLayout step={stepInfo.nowStep}>
      <div className="bg-bg w-full flex-1 flex justify-center">
        <div className="flex flex-col items-center mt-[124px] gap-3">
          <h1 className="text-[100px] font-bold gradient-text">{stepInfo.title}</h1>
          <div className="w-[432px] h-[432px]">
            <GredientCircularProgress 
              maxValue={stepInfo.timeArray[currentIndex] || 60} 
              value={count} 
            />
          </div>
        </div>
      </div>
      <BottomNav />
    </LandscapeProgramLayout>
  );
}

export default LandescapeScreen;
